import styled from "styled-components";

export type PrintStyleProps = "page-break-inside: avoid;" | "page-break-before: always;"


export const OnlyOnPrint = styled.div`

    display: none;

    @media print {
    
        display: block;
        
    }
`

export const PrintStyle = styled.div`
    @media print {
        @page{ 
            size: A4;   /* auto is the initial value */ 
            /* this affects the margin in the printer settings */ 
            margin: 25mm 25mm 25mm 25mm;
        } 
        
        body{ 
            /* this affects the margin on the content before sending to printer */ 
            margin: 0px;  
        } 

        h2{
            
        }

        /* page-break-inside: avoid; */
    }
`;


export const PrintBreakAfter = styled.div`

    page-break-after: always;
    display:block;
`;

export const PrintBreakBefore = styled.div`

    @media print {
        page-break-before: always;
        display:block;
    }
`;

export const PrintAvoidBreak = styled.div`

    break-inside: avoid;
    display:block;
`;


